import React, { useEffect } from "react";
import { SubservicesTabs } from "../../components/subservicesTabs/subservicesTabs";
import { Helmet } from "react-helmet";
import { Gallery } from "../../components/gallery/gallery";
import imgHead from "../../assets/imgs/servicios/congresos-eventos/congresos01.svg";
import { useTranslation } from "react-i18next";

import ico01 from "../../assets/imgs/servicios/congresos-eventos/Carrusel01.webp";
import ico02 from "../../assets/imgs/servicios/congresos-eventos/Carrusel02.webp";
import ico03 from "../../assets/imgs/servicios/congresos-eventos/Carrusel03.webp";
import ico04 from "../../assets/imgs/servicios/congresos-eventos/Carrusel04.webp";
import ico05 from "../../assets/imgs/servicios/congresos-eventos/Carrusel05.webp";
import ico06 from "../../assets/imgs/servicios/congresos-eventos/Carrusel06.webp";
export const galleryCongresos = [ico01, ico02, ico03, ico04, ico05, ico06];

export const CongresosEventosPage = () => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };
    scrollToTop();
  });
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>
          {t("Organización de congresos y eventos - JC Innovation")}
        </title>
      </Helmet>
      <section className="wrapper__page_services">
        <div className="contain__head_page">
          <div className="container-lg">
            {/* <div className="sec_head container_am">
             
            </div> */}
            <div className="sec_head_content container_am">
              <div className="fw_600">
                 <h2 className="ttls ttl_section c_morado mb-2 ">
                {t("Organización de Congresos")}
              </h2>
              <p className="paragraph lg c_marin fw_500 ">
                "{t("De principio a fin")}"
              </p>
                <p className="paragraph lg mb-5">
                  Satisfacemos las necesidades de tu evento de una manera única
                  y creativa en las mejores sedes del país.
                </p>
                <div>
                  <p className="paragraph lg">
                    ● Eventos presenciales, híbridos y virtuales.
                  </p>
                  <p className="paragraph lg">● Soluciones digitales.</p>
                  <p className="paragraph lg">● Producción visual.</p>
                  <p className="paragraph lg">● Transmisiones en vivo.</p>
                  <p className="paragraph lg">● Desarrollo web.</p>
                </div>
              </div>
              <img src={imgHead} alt={t("Organización de Congresos")} />
            </div>
          </div>
        </div>
        <SubservicesTabs />
        <Gallery images={galleryCongresos} title="Organización de congresos" />
      </section>
    </>
  );
};
